import Conditions from '../constants/conditions';
import CompanySettingsComponents from '../constants/companySettingsComponents';
import UserPermissions from '../constants/userPermissions';
import { PartialRecord, PermissionRules } from '../usePermissions';

type companySettingsComponentRegistry = {
  [name in CompanySettingsComponents]: PermissionRules;
};

const CompanySettingsComponentRegistry: companySettingsComponentRegistry = {
  CustomerNotificationsTab: {
    [UserPermissions.VIEW_CUSTOMER_NOTIFICATION_SETTINGS]: true,
    [UserPermissions.EDIT_CUSTOMER_NOTIFICATION_SETTINGS]: true,
  },
  CompanySettings: {
    [UserPermissions.VIEW_ORGANIZATION_SETTINGS]: true,
    [UserPermissions.EDIT_ORGANIZATION_SETTINGS]: true,
    [UserPermissions.EDIT_ORGANIZATION_PROFILE]: true,
    [UserPermissions.VIEW_TEAM_MEMBERS]: true,
    [UserPermissions.VIEW_BILLING]: true,
    [UserPermissions.VIEW_SERVICE_ACCOUNTS]: true,
  },
  WorkspaceSettingsTab: {
    [UserPermissions.VIEW_PROJECTS]: true,
    [UserPermissions.EDIT_PROJECTS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.workspaceDeleted) return false;
      return true;
    },
    [UserPermissions.DELETE_PROJECTS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.workspaceDeleted) return false;
      return true;
    },
    [UserPermissions.CREATE_PROJECTS]: true,
  },
  TeamSettingsTab: {
    [UserPermissions.INVITE_NEW_MEMBERS]: true,
    [UserPermissions.EDIT_TEAM_MEMBERS]: true,
    [UserPermissions.DELETE_TEAM_MEMBERS]: true,
  },
  BillingTab: {
    [UserPermissions.VIEW_BILLING]: true,
  },
  IntegrationsTab: {
    [UserPermissions.VIEW_SERVICE_ACCOUNTS]: true,
  },
  ShopifySettingsTab: {
    [UserPermissions.VIEW_ORGANIZATION_SETTINGS]: true,
    [UserPermissions.MANAGE_SHOPIFY_ACCOUNT]: true,
  },
  WebhooksTab: {
    [UserPermissions.VIEW_WEBHOOKS]: true,
    [UserPermissions.MANAGE_WEBHOOKS]: true,
  },
  CreateTokenButton: {
    [UserPermissions.CREATE_SERVICE_ACCOUNTS]: (conditions: PartialRecord<Conditions, boolean>) => {
      return !conditions.isSynced;
    },
  },
  RevokeTokenButton: {
    [UserPermissions.CREATE_SERVICE_ACCOUNTS]: (conditions: PartialRecord<Conditions, boolean>) => {
      return !conditions.isSynced;
    },
  },
};

export default CompanySettingsComponentRegistry;
